import { createMomentProvider } from "@shared/ui/MomentProvider";
import { en, ru } from "../i18n";

const momentLocales = {
    ru: ru.moment,
    en: en.moment
}
export const MomentProvider = createMomentProvider(momentLocales)